import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'daily-sign-badge',
  name: '每日一签',
  icon: '签',
  group: '国学组件',
  description: '展示每日签到、抽签状态和连续签到入口。',
  defaultProps: {
    title: '每日一签',
    subtitle: '签到抽取今日签文',
    badgeText: '可抽签',
    buttonText: '立即签到',
    link: '/pages/guoxue/daily-sign'
  }
}
